import React from "react";
import Marquee from "react-fast-marquee";
import { MANUFACTURERS } from "@/lib/site";
import { Overline } from "./Motion";

export const ManufacturerMarquee = () => {
  return (
    <section className="bg-white py-20 lg:py-28 border-y border-black/5 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mb-12">
        <Overline>Global manufacturers</Overline>
        <p className="mt-4 font-display text-2xl lg:text-3xl text-royal-deep max-w-2xl tracking-tight">
          We hand-pick and partner with the world&rsquo;s leading mills.
        </p>
      </div>
      <Marquee speed={40} gradient gradientColor="#ffffff" gradientWidth={120} data-testid="manufacturer-marquee">
        {MANUFACTURERS.map((m) => (
          <span
            key={m}
            className="font-display text-4xl lg:text-6xl text-royal-deep/25 hover:text-royal transition-colors duration-500 mx-12 lg:mx-20 tracking-tight"
          >
            {m}
          </span>
        ))}
      </Marquee>
    </section>
  );
};
